export const formatGetKbInfo = (json) => {
  let kbud = new Date(Date.parse(json.kbud));
  let dat = new Date(Date.parse(json.dat));
  let { ent, pub, pubp, url, lkbud } = json;
  return {
    creation_date: dat.toLocaleString(),
    entry_into_force: ent,
    html: json.html,
    kbt: json.kbt,
    last_updated: kbud.toLocaleString(),
    last_kb_updated: lkbud,
    name: json.nm,
    published: pub,
    place_published: pubp,
    short_name: json.sn,
    srt: json.srt,
    status: json.sts,
    source: url,
    user: json.usen,
  }
}

export const formatUpdateKbInfo = (json) => {
  let kbud = new Date(Date.parse(json.kbud));
  return {
    last_updated: kbud.toLocaleString(),
  }
}

/**
 * getKbItems y saveKbItems devuelven kbud como "2026-08-14 11:05:47", mientras
 * getKbInfo lo devuelve en ISO con T. La cadena con espacio no es un formato
 * que Date.parse tenga que reconocer, asi que se convierte antes.
 */
export const formatKbud = (kbud) => {
  if(!kbud) return '';
  let date = new Date(Date.parse(String(kbud).replace(' ', 'T')));
  return isNaN(date.getTime()) ? '' : date.toLocaleString();
}

